export default {
  pleaseWait: '少々お待ちください。',
  notLogin: 'ログインしてください。',
  confirm: 'これでいい',
  cancel: 'やめる',
  cancelTitle: 'ログイン認証をやめますか？',
  cancelMessage: 'この認証は５分以内に有効なので、時間外になったら、改めてアカウントを作ってください。'
};
